import { useCallback, useEffect, useRef } from "react"
import { BlockerFunction, useBlocker } from "react-router"

const useLocationBlocker = (when = true) => {
  const isMountedRef = useRef<boolean>(false)

  useEffect(() => {
    isMountedRef.current = true
    return () => {
      isMountedRef.current = false
    }
  }, [])

  const shouldBlock = useCallback<BlockerFunction>(
    ({ currentLocation, nextLocation }) =>
      when && isMountedRef.current && currentLocation.pathname !== nextLocation.pathname,
    [when],
  )

  return useBlocker(shouldBlock)
}

export { useLocationBlocker }
